<template>
  <div>
    <!-- Duplicate Filename -->
    <b-notification v-if="checkupStore.activeNotifications.DUPE_FILENAME">
      <p>Duplicate file names:</p>
      <ul>
        <li
          v-for="file in checkupStore.activeNotifications.DUPE_FILENAME.dupedFilenames"
          :key="file.fileName"
        >
          {{ file.fileName }}
        </li>
      </ul>
    </b-notification>

    
    <!-- No Matched Holdings -->
     <!-- No matched holdings but PDF holdings extraction was successful without errors -->
    <b-notification
      v-if="checkupStore.activeNotifications.SUCCESS_NO_MATCHED_HOLDINGS"
      type="is-warning"
    >
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
        <i class="fa fa-exclamation-triangle tw-text-2xl"></i>
        <div>
          <p class="tw-w-full">
            Your Upload(s) Succeeded! 
            Your holdings were extracted successfuly, BUT we were unable to match any of your holdings to a ticker symbol, so you won't be able to view any analytics.
            You can add tickers for any unmatched holdings from the Holdings Tab. You can edit them manually or run magic-ticker-fill to automatically search for the best match tickers.
          </p>
          <p
            v-for="statement in checkupStore.activeNotifications.SUCCESS_NO_MATCHED_HOLDINGS.statements"
            :key="statement"
            class="tw-font-bold"
          >
            {{ statement }}
          </p>
        </div>
      </div>
    </b-notification>
    <!-- No matched holdings PDF but there were other issues -->
    <b-notification
      v-if="checkupStore.activeNotifications.NO_MATCHED_HOLDINGS"
      type="is-warning"
    >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
      <i class="fa fa-exclamation-triangle tw-text-2xl"></i>
        <div>
          <p class="tw-w-full">
            We were unable to match any of your holdings to a ticker symbol, so you won't be able to view any analytics for the portfolios listed below.
            You can add tickers for any unmatched holdings from the Holdings Tab. You can edit them manually or run magic-ticker-fill to automatically search for the best match tickers.
          </p>
          <p
            v-for="statement in checkupStore.activeNotifications.NO_MATCHED_HOLDINGS.statements"
            :key="statement"
            class="tw-font-bold"
          >
            {{ statement }}
          </p>
        </div>
      </div>
    </b-notification>
    <!-- No matched holdings portfolio-->
    <b-notification
      v-if="checkupStore.activeNotifications.NO_MATCHED_HOLDINGS_PORTFOLIO"
      type="is-warning"
    >
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
        <i class="fa fa-exclamation-triangle tw-text-2xl"></i>
      </div>
      <p class="tw-w-full">
        For the portfolios listed below, we were unable to match any of the holdings to a ticker symbol, so you won't be able to view any analytics.
        You can still download a csv of your holdings.
        <br><br>
        You can add tickers for any unmatched holdings from the Holdings Tab! You can edit them manually or run magic-ticker-fill to automatically search for the best match tickers.
      </p>
      <p
        v-for="portfolio in checkupStore.activeNotifications.NO_MATCHED_HOLDINGS_PORTFOLIO.portfolios"
        :key="portfolio"
        class="tw-font-bold"
      >
        {{ portfolio }}
      </p>
    </b-notification>
    <!-- Successful upload-->
    <b-notification
      v-if="checkupStore.activeNotifications.SUCCESS_ALL"
      type="is-success"
    >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
        <i class="fa fa-check tw-text-2xl" />
        <div>
          <p class="tw-w-full">
            Your Upload(s) Succeeded! 
          </p>
          <p
            v-for="statement in checkupStore.activeNotifications.SUCCESS_ALL.statements"
            :key="statement"
            class="tw-font-bold"
          >
            {{ statement }}
          </p>
        </div>
      </div>
    </b-notification>


    <!-- Missing Ticker Symbols -->
     <!-- CASE 1: Missing ticker symbols PDF upload, but everything else was successful -->
    <b-notification
      v-if="checkupStore.activeNotifications.SUCCESS_MISSING_TICKER_SYMBOLS"
      type="is-success"
    >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
        <i class="fa fa-check tw-text-2xl" />
        <div>
          <p class="tw-w-full">
            Your Upload(s) Succeeded! 

            You can add tickers for any unmatched holdings from the Holdings Tab. You can edit them manually or run magic-ticker-fill to automatically search for the best match tickers.
          </p>
          <p
            v-for="statement in checkupStore.activeNotifications.SUCCESS_MISSING_TICKER_SYMBOLS.statements"
            :key="statement"
            class="tw-font-bold"
          >
            {{ statement }}
          </p>
        </div>
      </div>
    </b-notification>
    <b-notification
      v-if="checkupStore.activeNotifications.MISSING_TICKER_SYMBOLS"
      type="is-warning"
    >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
      <i class="fa fa-exclamation-triangle tw-text-2xl"></i>
      </div>
      <p class="tw-w-full">
            For the following uploads or portfolios, at least some of your holdings do not have ticker symbols, so analytics will not be available for those holdings.
            You can edit the tickers manually in the Holdings tab and you can also run magic-ticker-fill from the holdings tab to automatically search for the best match tickers.
          </p>
          <p
            v-for="statement in checkupStore.activeNotifications.MISSING_TICKER_SYMBOLS.statements"
            :key="statement"
            class="tw-font-bold"
          >
            {{ statement }}
          </p>
    </b-notification>
    <!-- Missing Ticker Symbols -- Selected Portfolios not uploaded-->
        <b-notification
      v-if="checkupStore.activeNotifications.MISSING_TICKER_SYMBOLS_PORTFOLIO"
      type="is-warning"
    >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
      <i class="fa fa-exclamation-triangle tw-text-2xl"></i>
      </div>
      <p class="tw-w-full">
            For the portfolios below at least some of your holdings did not have ticker symbols, so analytics will not be available for those holdings.
            You can edit the tickers manually in the Holdings tab and you can also run magic-ticker-fill from the holdings tab to automatically search for the best match tickers.
          </p>
          <p
            v-for="portfolio in checkupStore.activeNotifications.MISSING_TICKER_SYMBOLS_PORTFOLIO.portfolios"
            :key="portfolio"
            class="tw-font-bold"
          >
            {{ portfolio }}
          </p>
    </b-notification>


    <!-- Account Totals Unavailable -->
    <b-notification
      v-if="checkupStore.activeNotifications.ACCOUNT_TOTALS_UNAVAILABLE"
      type="is-warning"
    >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
      <i class="fa fa-exclamation-triangle tw-text-2xl"></i>
      </div>
      <p class="tw-w-full">
            We were unable to verify the total value of the following statements.
            Please double check that the portfolio total in the holdings tab matches the statement. Someone from the YourStake team will follow up if necessary.
          </p>
          <p
            v-for="statement in checkupStore.activeNotifications.ACCOUNT_TOTALS_UNAVAILABLE.statements"
            :key="statement"
            class="tw-font-bold"
          >
            {{ statement }}
          </p>
    </b-notification>


    <!-- Missing Accounts -->
    <b-notification
      v-if="checkupStore.activeNotifications.MISSING_ACCOUNTS"
      type="is-warning"
    >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
      <i class="fa fa-exclamation-triangle tw-text-2xl"></i>
      </div>
      <p class="tw-w-full">
            For the statements below, we either didn't find a summary page listing accounts and totals, or we found accounts on the summary page but no holdings for that account.
            Some statements list additional accounts in the summary page, or this may mean that some pages are missing in the upload.
            To be safe, please double check that all relevant accounts are included.
          </p>
          <p
            v-for="statement in checkupStore.activeNotifications.MISSING_ACCOUNTS.statements"
            :key="statement"
            class="tw-font-bold"
          >
            {{ statement }}
          </p>
    </b-notification>


    <!-- Holdings Sum Mismatch -->
    <b-notification
      v-if="checkupStore.activeNotifications.HOLDINGS_SUM_MISMATCH"
      type="is-warning"
    >
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
      <i class="fa fa-exclamation-triangle tw-text-2xl"></i>
      </div>
      <p class="tw-w-full">
            For the statements below, the sum of holdings does not match the total in the summary section.
            Please double check that the document uploaded includes all pages that contain holdings for the account.
            The YourStake Team has been notified and will correct and complete the upload and notify you within one business day.
          </p>
          <p
            v-for="statement in checkupStore.activeNotifications.HOLDINGS_SUM_MISMATCH.statements"
            :key="statement"
            class="tw-font-bold"
          >
            {{ statement }}
          </p>
    </b-notification>

    <!-- Upload never started (often because the file was too large or not a pdf) -->
    <b-notification
      v-if="uploadInvalidFilesWithoutPasswordProtected.length"
      type="is-link"
    >
      <div class="tw-flex tw-items-center tw-gap-3">
        <p class="tw-max-w-sm">
          Something went wrong while trying to upload the documents below. Please make sure the files below are PDFs and the size of each PDF is below 50.0 MB.
        </p>
        <div
          v-for="file in uploadInvalidFilesWithoutPasswordProtected"
          :key="file.name"
          class="tw-max-w-sm"
        >
          <p class="tw-font-bold">
            {{ file.name }}
          </p>
        </div>
      </div>
    </b-notification>
    <!-- PW Protected file, failed -->
    <b-notification
      v-if="passwordProtectedFiles.length"
      type="is-link"
    >
      <div class="tw-flex tw-items-center tw-gap-3">
        <i class="fa fa-lock tw-text-2xl" />
        <div>
          <p class="tw-max-w-sm">
            The following statements could not be processed because they are password-protected, encrypted, corrupt, or empty.
            Please check the file content.
          </p>
          <div
            v-for="file in passwordProtectedFiles"
            :key="file.name"
            class="tw-max-w-sm"
          >
            <p class="tw-font-bold">
              {{ file.name }}
            </p>
          </div>
        </div>
      </div>
    </b-notification>



    <!-- Upload failed completely (task failed) -->
    <b-notification
      v-if="checkupStore.uploadFailedFiles?.length"
      type="is-link"
    >
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
        <p class="tw-max-w-sm">
          Something went wrong while trying to upload and process the documents below. Our system identified the document(s) you uploaded as: {{ documentTypes }}.
          The YourStake Team has been notified and will correct and complete the upload if it was a brokerage statement and notify you within one business day.
          You can still download the raw data extracted from the pdf(s) below.
        </p>
        <div
          v-for="file in checkupStore.uploadFailedFiles"
          :key="file.name"
          class="tw-max-w-sm"
        >
          <p class="tw-font-bold">
            {{ file.name }}
          </p>
          <a
            v-if="file.rawDataZipFile"
            class="tw-text-sm"
            :href="file.rawDataZipFile.url"
          >Raw data zipfile</a>
        </div>
      </div>
    </b-notification>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  computed: {
    ...mapStores(useCheckupStore),
    documentTypes() {
      if (!this.checkupStore.uploadFailedFiles?.length) {
        return '';
      }
      const types = this.checkupStore.uploadFailedFiles.map(file => file?.rawDataZipFile?.document_type);
      if (types.length <= 1) {
        return types[0];
      }
      return types.slice(0, -1).join(', ') + ', and ' + types[types.length - 1];
    },
    passwordProtectedFiles() {
    return this.checkupStore.files.filter(file => file.isPasswordProtected);
    },
    uploadInvalidFilesWithoutPasswordProtected() {
      const invalid= this.checkupStore.uploadInvalidFiles.filter(file => !file.isPasswordProtected);
      console.log('invalid', invalid)
      return invalid
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>

<style scoped>
.notification.is-success {
  background-color: #d4edda; /* Light green background */
  border: 1px solid #c3e6cb; /* Green border */
  color: #155724; /* Dark green text */
  padding: 16px; /* Padding inside the box */
  border-radius: 8px; /* Rounded corners */
}
.notification.is-success .fa-check {
  color: #155724; /* Dark green color for the checkmark icon */
}
</style>
